module.exports = __webpack_public_path__ + "static/media/3d-button.7bfb8b3b.png";